import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {Form, Select} from 'antd';
import {selectAuth} from '@app/redux/selectors';
import {connect} from 'react-redux';
import {SortOptions} from '@app/components/common/Filters/SortOptions';
import {RQUseGetLocationByDivision} from '@app/reactQuery/apis';

const SingleSelectLocationByDivisionIDAttribute = ({auth, attributeMetadata}) => {

  const form = Form.useFormInstance();

  const parentIdValue = form.getFieldValue(attributeMetadata?.input_parent_id);

  useEffect(() => {
    form.setFieldsValue({
      [attributeMetadata.id]: undefined,
    });
  }, [form, parentIdValue, attributeMetadata.id]);

  const {data} = RQUseGetLocationByDivision({
    certificate: auth?.certificate,
    divisionId: parentIdValue || '',
  },
  {
    enabled: !!parentIdValue,
  },
  );

  const filterOption = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  return (
    <Form.Item
      name={[attributeMetadata.id]}
      label={attributeMetadata.label}
      rules={attributeMetadata.validation_rules}
    >
      <Select
        allowClear={true}
        showSearch
        filterOption={filterOption}
        virtual={false}
        placeholder={attributeMetadata?.placeholder}
        disabled={!attributeMetadata.editable}
        options={SortOptions(data)?.map((object, index) => {
          return {
            value: object?.employeeId || '',
            label: object?.locationName || '',
          };
        })}
      />
    </Form.Item>
  );
};

SingleSelectLocationByDivisionIDAttribute.propTypes = {
  auth: PropTypes.shape({
    certificate: PropTypes.string.isRequired,
  }).isRequired,
  attributeMetadata: PropTypes.shape({
    id: PropTypes.string.isRequired,
    partName:PropTypes.string,
    editable: PropTypes.bool,
    validation_rules: PropTypes.array,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    input_search_enable: PropTypes.bool,
    input_parent_id: PropTypes.string,
  }).isRequired,
};

const mapState = state => {
  const auth = selectAuth(state);
  return {auth};
};

export default connect(mapState)(SingleSelectLocationByDivisionIDAttribute);
